// Single source of truth for "can this product be added to the cart right
// now" — issue #138. Before this, ProductView.jsx dispatched ADD guarded
// only on soldOut (stock <= 0), while the shared AddToCartBtn in
// components/ui.jsx additionally refused once the cart already held every
// unit in stock (atStockLimit). Same product, two different answers.
//
// Both call sites now derive their state from this pure function; neither
// keeps its own stock arithmetic. The two buttons still look different
// (compact "+ Cart" in the grid vs. a large full-width button on the product
// page) — only the decision is shared, not the presentation.
export function getCartStockState(product, cart) {
  const cartQty = cart.find(i => i.id === product.id)?.qty ?? 0;
  const soldOut = product.stock != null && product.stock <= 0;
  const atStockLimit = product.stock != null && cartQty >= product.stock;
  const canAdd = !soldOut && !atStockLimit;
  return { cartQty, soldOut, atStockLimit, canAdd };
}
